import { render } from "./ProyectosDeCooperacionView.vue?vue&type=template&id=7f31e65e"
import script from "./ProyectosDeCooperacionView.vue?vue&type=script&lang=js"
export * from "./ProyectosDeCooperacionView.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__